module.exports = __webpack_public_path__ + "static/img/sdnlab.0d203429.png";